import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo2.png'


const _withScopeId = n => (_pushScopeId("data-v-3751bfd1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "admin-side" }
const _hoisted_2 = { class: "side-logo" }
const _hoisted_3 = {
  key: 0,
  class: "logo-text"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "代理中心", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "插件中心", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardOutlined = _resolveComponent("DashboardOutlined")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_TeamOutlined = _resolveComponent("TeamOutlined")!
  const _component_AppstoreOutlined = _resolveComponent("AppstoreOutlined")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!

  return (_openBlock(), _createBlock(_component_a_layout_sider, {
    width: 200,
    class: "admin-sider"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _imports_0,
            class: _normalizeClass(["logo-img", { hidden: _ctx.logoFailed }]),
            onError: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logoFailed = true)),
            onLoad: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logoFailed = false))
          }, null, 34),
          (_ctx.logoFailed)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "管理后台"))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_a_menu, {
          theme: "dark",
          mode: "inline",
          "inline-collapsed": _ctx.isCollapse,
          "selected-keys": _ctx.selectedKeys,
          "open-keys": _ctx.openKeys,
          "onUpdate:openKeys": _ctx.handleOpenKeysChange,
          class: "side-menu"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_sub_menu, { key: "1" }, {
              icon: _withCtx(() => [
                _createVNode(_component_DashboardOutlined)
              ]),
              title: _withCtx(() => [
                _createTextVNode("数据中心")
              ]),
              default: _withCtx(() => [
                _createVNode(_component_a_menu_item, {
                  key: "1-1",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigateTo('/admin/')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("控制台")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_menu_item, {
                  key: "1-2",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navigateTo('/admin/withdrawal')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("提现中心")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_menu_item, {
                  key: "1-3",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.navigateTo('/userManage')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("用户管理")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, {
              key: "2",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.navigateTo('/admin/')))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_TeamOutlined)
              ]),
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, {
              key: "3",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.navigateTo('/admin/')))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_AppstoreOutlined)
              ]),
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["inline-collapsed", "selected-keys", "open-keys", "onUpdate:openKeys"])
      ])
    ]),
    _: 1
  }))
}